import { useState } from "react";
import { formatCommaNumbers } from "../../Utils/common.utils";
import {
  CMFinancials,
  LoadContent,
  ToolTipContent,
  TransactionContend,
} from "./financials.styles";
import { useEffect } from "react";
import { useAuth } from "../../Contexts/auth.context";
import { getMarketcap, user_profile } from "../../Services/prod/auth.service";
import { useLocation } from "react-router-dom";
import { createTheme, ThemeProvider, Tooltip, useMediaQuery } from "@mui/material";
import arrowUpdate from "../../icons/arrow-update.png";
import LoadingChild from "../loading-child/loading-child.component";
import HelpTooltip from "../help-tooltip/help-tooltip.component";


const Financials = ({financialLoading, pairlistData = [],auction, tradingTemplate,financials, ...props }) => {
  const apiURL = process.env.REACT_APP_PATH;
  const [showTooltip, setShowTooltip] = useState(false);
  const { auth } = useAuth();
  const [marketCapData, setMarketcapData] = useState([]);
  const [userProfile, setUserProfile] = useState([]);
  const location = useLocation();
  const url = window.location.href;
  const styleConfig = url.includes("trading-board")
    ? { marginTop: "50px" }
    : { marginTop: "0px" };
  const isMobile = useMediaQuery("(max-width:992px)");
  const [reload, setReload] = useState(false);

  const theme = createTheme({
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            maxWidth: '1000px !important',
          },
        },
      },
    },
  });

  const isTradingBoardWithId = () => {
    const path = location.pathname;
    return /^\/trading-board\/[^/]+$/.test(path);
  };

  const fetchMarketcap = async () => {
    setReload(true);
    try {
      const data = await getMarketcap(auction?.id);
      if (data) {
        setMarketcapData(data?.data);
      }
    } catch (error) {
      console.error("Error fetching market cap:", error);
    } finally {
      setReload(false);
    }
  };

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const data = await user_profile(auth.userId);
        if (data) {
          setUserProfile(data);
        }
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };

    fetchUserProfile();
  }, []);

  useEffect(() => {
    if (isTradingBoardWithId() && auth) {
      fetchMarketcap();
    }
  }, [auction?.id, useLocation,financials]); 

  const handleShowDistributorsClick = () => {
    setShowTooltip(!showTooltip);
  };

  const handleScrollToTracks = () => {
    const element = document.getElementById("tracks");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const ListingDetailsLink = () => {
    if (!auction || !auction.ListingDetails) {
      return <div></div>;
    }
    const isExternalLink = auction.ListingDetails.startsWith("https");
    const url = isExternalLink
      ? auction.ListingDetails
      : `https://${apiURL}${auction.ListingDetails}`;

    return (
      <div>
        <div>Listing Details</div>
        <div style={{ textAlign: isMobile ? "left" : "right" }}>
          <a target="_blank" href={url} rel="noopener noreferrer">
            Details
          </a>
        </div>
      </div>
    );
  };

  const handleButtonClick = () => {
    var test2 = "";
    fetchMarketcap();
  };
  /*test edit */

  const parsedDistributors = auction.distributors
    ? auction.distributors.includes("[")
      ? auction.distributors
          .split("],")
          .map((group) => {
            const fixed = group.trim();
            const jsonStr = fixed.endsWith("]") ? fixed : fixed + "]";
            try {
              return JSON.parse(jsonStr);
            } catch (e) {
              console.warn("JSON parse error::", jsonStr);
              return [];
            }
          })
          .flat()
      : auction.distributors.split(",").map((dist) => dist.trim())
    : [];

  const uniqueDistributors = Array.from(
    new Set(parsedDistributors.flat().map((d) => d.trim()))
  );

  return (
    <CMFinancials className="auction-financials " {...props}>
      {financialLoading ? (
        <div style={{width:"50%" ,padding:"60px 0"}}>

          <LoadingChild />
        </div>
      ) : (
        <div className="financials">
          <h3>Financials</h3>
          <div className="financials-details">
            <div>
              <div className="tooltip-content">Last 12 Months' Earnings <HelpTooltip title={"Royalties collected in the past 12 months representing full annum (note: royalty payments typically lag song usage by 1–2 quarters)."} /></div>
              <div style={{ textAlign: "right" }}>
                {auction["Last12MonthsEarningsStr"] || "- -"}
              </div>
            </div>
            <div>
              <div className="tooltip-content">3 Year Average Earnings  <HelpTooltip title={"Average yearly royalties earned over the last three years.(Average may be applied to shorter available periods if the song was released later)."} /></div>
              <div style={{ textAlign: "right" }}>
                {auction["3YearAverageEarningStr"] || "- -"}
              </div>
            </div>
            <div>
              <div  className="tooltip-content">Last 12 Months Yield <HelpTooltip title={"Annual return (%) based on last 12 months' earnings divided by total unit value (Market Cap)."} /></div>
              <div style={{ textAlign: "right" }}>
                {pairlistData[0]?.months_12_yield
                  ? pairlistData[0]?.months_12_yield + "%"
                  : auction["Last12MonthsYieldStr"] || "- -"}{" "}
              </div>
            </div>
            <div>
              <div className="tooltip-content">3-Year Average yield <HelpTooltip title={"Average annual return (%) based on the past 3 years of earnings. (Average may be applied to shorter available periods if the song was released later)."} /></div>
              <div style={{ textAlign: "right" }}>
                {pairlistData[0]?.years_3_yield
                  ? pairlistData[0]?.years_3_yield + "%"
                  : auction["3YearAverageYieldStr"] || "- -"}
              </div>
            </div>
            <div>
              <div className="tooltip-content">Dollar Age <HelpTooltip title={"Weighted average age of the royalties — shows how long the symbol has been generating income and its long-term stability."} /></div>
              <div style={{ textAlign: "right" }}>
                {auction["DollarAgeStr"] || "- -"}
              </div>
            </div>
            <div>
              <div  className="tooltip-content">Earning's Multiple (P/E) <HelpTooltip title={"Unit value divided by the past 12 months' earnings — a valuation ratio."} /></div>
              {reload ? (
                <LoadContent>
                  <LoadingChild size={20} />
                </LoadContent>
              ) : (
                <div style={{ textAlign: "right" }}>
                  {isTradingBoardWithId()
                    ? (auth ? (marketCapData?.PEValue ? formatCommaNumbers(marketCapData?.PEValue.toFixed(1)) + "x" : "0x") : "- -")
                    : auction["EarningMultiplePEStr"] || "- -"}
                </div>
              )}
            </div>
            <div>
              <div className="tooltip-content">Market Cap <HelpTooltip title={"Total number of units × unit price (either from the auction or secondary market)."} /></div>
              {reload ? (
                <LoadContent>
                  <LoadingChild size={20} />
                </LoadContent>
              ) : (
                <div
                  style={{
                    textAlign: "right",
                    display: "flex",
                    justifyContent: "flex-end",
                  }} 
                >
                  {isTradingBoardWithId()
                    ? (auth ? "$" + formatCommaNumbers(marketCapData?.marketcap) : "- -")
                    : auction["MarketCapStr"] || ""}
                  {isTradingBoardWithId() && (
                    <TransactionContend
                      className="transaction-button"
                      onClick={handleButtonClick}
                      disabled={reload}
                    >
                      <img src={arrowUpdate} />
                    </TransactionContend>
                  )}
                </div>
              )}
            </div>

            {/*auction.financials
            ? Object.keys(auction.financials).map((item, index) => {
                return (
                
                  <div key={index}>
                    <div>
                      {auction.financials[item].title}
                    </div>
                    <div style={{ textAlign: "right" }}>
                      {auction.financials[item].title === "Last 12 Months' Earnings" && (
                        auction.financials[item].description
                      )}
                      {auction.financials[item].title === "3 Year Average Earnings" && (
                        auction.financials[item].description
                      )}
                       {auction.financials[item].title === "Last 12 Months Yield" && (
                        auction.financials[item].description
                      )}
                      {auction.financials[item].title === "3-Year Average yield" && (
                        auction.financials[item].description
                      )}
                       {auction.financials[item].title === "Dollar Age" && (
                        auction.financials[item].description
                      )}
                      {auction.financials[item].title === "Earning's Multiple (P/E)" && (
                        auction.financials[item].description
                      )}
                      {auction.financials[item].title === "Market Cap" && (
                        auction.financials[item].description
                      )}
                    </div>
                  </div>
                );
              })
            : ""*/}
          </div>
        </div>
      )}
      <div className="included-rights" style={styleConfig}>
        <h3>Included Rights</h3>
        <div>
          <div>
            <div>Issuer Name</div>
            <div style={{ textAlign: isMobile ? "left" : "right" }}>
              {auction.issuerName || "- -"}
            </div>
          </div>
          {/* <div>
            <div>Master</div>
            <div style={{ textAlign: isMobile ? "left" : "right" }}>Not included</div>
          </div> */}
          {/*<div>
            <div>Record label</div>
            <div style={{ textAlign: isMobile ? "left" : "right" }}>- -</div>
          </div>
          <div>
            <div>Auction ID</div>
            <div style={{ textAlign: isMobile ? "left" : "right" }}>{auction.auctionID || "- -"}</div>
          </div>*/}
          <div>
            <div className="tooltip-content">Musical Composition <HelpTooltip title={"Refers to the publishing (songwriting) side of royalties."} /></div>
            <div style={{ textAlign: isMobile ? "left" : "right" }}>
              {auction.MusicalComposition || "- -"}
            </div>
          </div>
          <div>
            <div className="tooltip-content">Listing Term <HelpTooltip title={"Typically, the duration of copyright: life of the author + 70 years, or ~100 years for corporate rights."} /></div>
            <div style={{ textAlign: isMobile ? "left" : "right" }}>
              {auction.listing_term || "- -"}
            </div>
          </div>
          <div>
            <div  className="tooltip-content">Sound Recording <HelpTooltip title={"Refers to the master recording rights held by the performing artist and label."} /></div>
            <div style={{ textAlign: isMobile ? "left" : "right" }}>
              {auction.SoundRecording || "- -"}
            </div>
          </div>
          <div>
            <div className="tooltip-content">Copyrights <HelpTooltip title={"MusicBull does not allow the sale of copyright ownership — only the right to receive future royalties."} /></div>
            <div style={{ textAlign: isMobile ? "left" : "right" }}>
              {auction.copyrights || "- -"}
            </div>
          </div>
          <div>
            <div>Royalty Dates</div>
            <div style={{ textAlign: isMobile ? "left" : "right" }}>
              {auction.RoyaltyDistributionDates || "- -"}
            </div>
          </div>
          {ListingDetailsLink()}
          <div>
            <div>Collection Agents</div>
            <div style={{ textAlign: isMobile ? "left" : "right" }}>
              {auction.distributors ? (
                <button
                  onClick={handleShowDistributorsClick}
                  className="open-button"
                >
                  Show Collection Agents
                </button>
              ) : (
                "- -"
              )}

              {showTooltip && (
                <ThemeProvider theme={theme}>
                    <ThemeProvider theme={theme}>
                    <Tooltip
                      title={
                        <ToolTipContent>
                          <div className="header_tool">
                            <h5>Collection Agents</h5>
                            <button
                              className="close_tool"
                              onClick={() => setShowTooltip(false)}
                            >x</button>
                          </div>
                          <ul style={{ listStyleType: 'none', padding: 0 }}>
                          <ul style={{ listStyleType: "none", padding: 0 }}>
                        {uniqueDistributors.map((distributor, index) => (
                          <li key={index}>{distributor}</li>
                        ))}
                      </ul>
                          </ul>
                        </ToolTipContent>
                      }
                      open={showTooltip}
                      onClose={() => setShowTooltip(false)}
                    >
                    </Tooltip>
                  </ThemeProvider>
                </ThemeProvider>
              )}
            </div>
          </div>
          <div>
            <div></div>
            <div style={{ textAlign: isMobile ? "left" : "right" }}></div>
          </div>
          <div>
            <div># Track(s) / Song(s)</div>
            <div style={{ textAlign: isMobile ? "left" : "right" }}>
              {auction.tracks ? (
                <>
                  {location.pathname !== "/auctions-board/auction" &&
                    !location.pathname.startsWith("/trading-board/") &&
                    (location.pathname === "/auction-preview" ? (
                      <p>
                        {auction.totaltracks
                          ? auction.totaltracks
                          : [
                              ...new Set(
                                Object.values(
                                  auction.tracks.reduce((acc, track) => {
                                    if (
                                      !acc[track.id] ||
                                      track.mediaChannel === "music"
                                    ) {
                                      acc[track.id] = track.id;
                                    }
                                    return acc;
                                  }, {})
                                )
                              ),
                            ].length || "- -"}
                      </p>
                    ) : (
                      <a
                        href={`/auctions-board/auction?id=${auction.auctionID}&scrollTo=tracks`}
                      >
                        {auction.totaltracks
                          ? auction.totaltracks
                          : [
                              ...new Set(
                                Object.values(
                                  auction.tracks.reduce((acc, track) => {
                                    if (
                                      !acc[track.id] ||
                                      track.mediaChannel === "music"
                                    ) {
                                      acc[track.id] = track.id;
                                    }
                                    return acc;
                                  }, {})
                                )
                              ),
                            ].length || "- -"}
                      </a>
                    ))}

                  {(location.pathname === "/auctions-board/auction" ||
                    location.pathname.startsWith("/trading-board/")) && (
                    <a onClick={handleScrollToTracks}>
                      {auction.totaltracks
                        ? auction.totaltracks
                        : [
                            ...new Set(
                              Object.values(
                                auction.tracks.reduce((acc, track) => {
                                  if (
                                    !acc[track.id] ||
                                    track.mediaChannel === "music"
                                  ) {
                                    acc[track.id] = track.id;
                                  }
                                  return acc;
                                }, {})
                              )
                            ),
                          ].length || "- -"}
                    </a>
                  )}
                </>
              ) : (
                "- -"
              )}
            </div>
          </div>

          {/*<div>
            <div>Master</div>
            <div style={{ textAlign: "right" }}>Not included</div>
            </div>
          <div>
            <div>Symbol type</div>
            <div style={{ textAlign: "right" }}>{auction.symbolType || "- -"}</div>
          </div>
          <div>
            <div>Royalty Distribution Dates</div>
            <div style={{ textAlign: "right" }}>- -</div>
          </div>
*/}
          {/*auction.rights
            ? Object.keys(auction.rights).map((item, index) => {
                return (
                  <div key={index}>
                    <div>
                      {auction.rights[item].title}
                    </div>
                    <div style={{ textAlign: "right" }}>
                      
                    {/*auction.rights[item].title === 'Distributors'?
                      auction?.distributors :
                      auction.rights[item].description
                }
                      {auction.rights[item].title === "Musical Composition" && (
                        auction.rights[item].description
                      )}
                      {auction.rights[item].title === "Sound Recording" && (
                        auction.rights[item].description
                      )}
                      {auction.rights[item].title === "Distributors" && (
                        auction.rights[item].description
                      )}
                      {auction.rights[item].title === "Copyrights" && (
                        auction.rights[item].description
                      )}
                      {auction.rights[item].title === "Symbol type" && (
                        auction.symbolType
                      )}
                      {auction.rights[item].title === "Listing Term" && (
                        auction.rights[item].description
                      )}
                      {auction.rights[item].title === "Royalty Distribution Dates" && (
                        auction.rights[item].description
                      )}
                      {auction.rights[item].title === "Number of tracks" && (
                        auction.rights[item].description
                      )}
                      {auction.rights[item].title === "Record lable" && (
                        auction.rights[item].description
                      )}

                    </div>
                  </div>
                );
              })
            : ""*/}
        </div>
      </div>
    </CMFinancials>
  );
};

export default Financials;
